import Box from '@mui/material/Box'
import { KestrixLogo, KestrixTypography } from '@shared'

export const LoginHeader = () => {
  return (
    <Box sx={{ mb: 5, textAlign: 'center' }}>
      <Box sx={{ mb: 1 }}>
        <KestrixLogo />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <KestrixTypography
          variant="h5"
          color="title"
          weight="semibold"
          align="center"
        >
          Kestrix
        </KestrixTypography>
        <KestrixTypography
          variant="body1"
          color="subtitle"
          weight="regular"
          align="center"
        >
          Quantify heat loss at scale
        </KestrixTypography>
      </Box>
    </Box>
  )
}
